const ACTIVE_CLASS = "active";
const ACTIVE_LINE_CLASS = "active_line";

const SITE_NAVIGATION_MENU_SELECTOR = ".site-navigation__menu";
const MENU_ITEM_SELECTOR = ".menu-item";

jQuery(document).ready(function ($) {
  const distanceToTop = 100;

  function updateActiveMenuItem() {
    var hash = window.location.hash;

    $(`${SITE_NAVIGATION_MENU_SELECTOR} ${MENU_ITEM_SELECTOR}`).removeClass(
      ACTIVE_LINE_CLASS
    );

    if (hash === "" || hash === "#") {
      $(`${SITE_NAVIGATION_MENU_SELECTOR} ${MENU_ITEM_SELECTOR} a[href='#']`)
        .parent(MENU_ITEM_SELECTOR)
        .addClass(ACTIVE_LINE_CLASS);
    }

    if (hash) {
      $(
        `${SITE_NAVIGATION_MENU_SELECTOR} ${MENU_ITEM_SELECTOR} a[href="${hash}"]`
      )
        .parent(MENU_ITEM_SELECTOR)
        .addClass(ACTIVE_LINE_CLASS);
    }
  }

  function updateActiveMenuItemOnScroll() {
    var fromTop = $(window).scrollTop();
    var hash = window.location.hash;

    if (hash !== "" || hash !== "#") {
      $(`${SITE_NAVIGATION_MENU_SELECTOR} ${MENU_ITEM_SELECTOR}`).removeClass(
        `${ACTIVE_CLASS}`
      );
    }

    $(`${SITE_NAVIGATION_MENU_SELECTOR} ${MENU_ITEM_SELECTOR} a`).each(
      function () {
        var href = $(this).attr("href");
        var section = $(href);

        if (
          section.length &&
          section.offset().top - distanceToTop < fromTop &&
          section.offset().top + section.height() > fromTop
        ) {
          $(this).parent(MENU_ITEM_SELECTOR).addClass(ACTIVE_CLASS);
        }
      }
    );

    if (fromTop <= distanceToTop) {
      $(`${SITE_NAVIGATION_MENU_SELECTOR} ${MENU_ITEM_SELECTOR} a[href='#']`)
        .parent(MENU_ITEM_SELECTOR)
        .addClass(ACTIVE_CLASS);
    }
  }

  updateActiveMenuItem();
  updateActiveMenuItemOnScroll();

  $(window).on("hashchange", function () {
    updateActiveMenuItem();
  });

  $(window).on("scroll", function () {
    updateActiveMenuItemOnScroll();
  });
});
